import { Button, Col, Empty, LegacyCard, Row, Space, Typography } from "@payping/web-components";
import { Add } from "@payping/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FC } from "react";
import { DashboardRoutes } from "@/router";
import { useAppTranslation } from "@/utils";
import { DropdownButton } from "@/core/component";

const EmptyProductList: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useAppTranslation();

  return (
    <Empty
      description={
        <Space orientation={"vertical"} size={"small"} className={"tw:w-full"}>
          <Typography.Text strong>{t("product.emptyList.title")}</Typography.Text>
          <Typography.Text>{t("product.emptyList.content")}</Typography.Text>
          <DropdownButton
            className={"tw:flex tw:justify-center"}
            key={0}
            buttonIcon={<Add width={14} height={14} />}
            menu={{
              items: [
                {
                  key: "1",
                  label: t("product.createBulk.createGroupViaExcel"),
                  onClick: (): void => {
                    navigate(
                      { pathname: DashboardRoutes.myShop.product.createBulk.url },
                      { state: { locationSearch: location.search } },
                    );
                  },
                },
              ],
            }}
            type={"primary"}
            onClick={(): void =>
              navigate(
                { pathname: DashboardRoutes.myShop.product.create.url },
                { state: { locationSearch: location.search } },
              )
            }
          >
            {t("add.button", { subject: t("product.title") })}
          </DropdownButton>
        </Space>
      }
    >
      <Row gutter={[8, 8]} className={"tw:w-full"}>
        <Col xs={24} md={12}>
          <LegacyCard.Ant className="tw:text-start">
            <Space orientation={"vertical"} size={"small"} className={"tw:w-full"}>
              <Typography.Text type={"secondary"} className={"tw:text-[0.65rem]"}>
                {t("product.emptyList.cards.prodcut.upperTitle")}
              </Typography.Text>
              <Typography.Text strong> {t("product.emptyList.cards.prodcut.title")}</Typography.Text>
              <Typography.Text type={"secondary"}>{t("product.emptyList.cards.prodcut.content")}</Typography.Text>
              <Space>
                <Link to={DashboardRoutes.connections.developers.root.url}>
                  <Button type={"link"} className={"tw:p-0!"}>
                    {t("common.receiveToken")}
                  </Button>
                </Link>

                <Link to={DashboardRoutes.connections.developers.root.url}>
                  <Button type={"link"} className={"tw:p-0!"}>
                    {t("common.guideToTechnicalDocumentation")}
                  </Button>
                </Link>
              </Space>
            </Space>
          </LegacyCard.Ant>
        </Col>
        <Col xs={24} md={12}>
          <LegacyCard.Ant className="tw:text-start">
            <Space orientation={"vertical"} size={"small"} className={"tw:w-full"}>
              <Typography.Text type={"secondary"} className={"tw:text-[0.65rem]"}>
                {t("product.emptyList.cards.plugins.upperTitle")}
              </Typography.Text>
              <Typography.Text strong> {t("product.emptyList.cards.plugins.title")}</Typography.Text>
              <Typography.Text type={"secondary"}>{t("product.emptyList.cards.plugins.content")} </Typography.Text>
              <Link to={DashboardRoutes.connections.developers.root.url}>
                <Button type={"link"} className={"tw:p-0!"}>
                  {t("common.readMore")}
                </Button>
              </Link>
            </Space>
          </LegacyCard.Ant>
        </Col>
      </Row>
    </Empty>
  );
};

export default EmptyProductList;
